// ** Icons Import
import { FilePlus, Circle, User, Trello, Clipboard } from 'react-feather'

export default [
  {
    header: 'report section'
  },
  {
    id: 'report',
    title: 'Report',
    icon: <FilePlus size={20} />,
    children: [
      {
        id: 'purchase',
        title: 'Purchase',
        icon: <Circle size={12} />,
        children: [
            {
              id: 'overAllReport',
              title: 'OverAll Report ',
              icon: <Circle size={12} />,
              navLink: '/reports/purchase/overAll-report'
            },
            {
                id: 'productwiseReport',
                title: 'ProductWise R ',
                icon: <Circle size={12} />,
                navLink: '/reports/purchase/productwise-report'
              },
              {
                id: 'oilReport',
                title: 'Oil Report ',
                icon: <Circle size={12} />,
                navLink: '/reports/purchase/oil-report'
              },
              {
                id: 'oilReport-2',
                title: 'Oil  Report-2 ',
                icon: <Circle size={12} />,
                navLink: '/reports/purchase/oil-report-2'
              },
              {
                id: 'monthlyPurchseFuel',
                title: 'Monthly Purchse Fuel ',
                icon: <Circle size={12} />,
                navLink: '/reports/purchase/monthlyPurchseFuel'
              },
              {
                id: 'lfr',
                title: 'LFR ',
                icon: <Circle size={12} />,
                navLink: '/reports/purchase/lfr-report'
              }
        ]
      },
      {
        id: 'sale',
        title: 'Sale',
        icon: <Circle size={12} />,
        children: [
            {
              id: 'saleReport',
              title: 'Sale Report ',
              icon: <Circle size={12} />,
              navLink: '/reports/sale/sale-report'
            },
            {
                id: 'tankWise',
                title: 'TankWise R',
                icon: <Circle size={12} />,
                navLink: '/reports/sale/tankWise-report'
              },
              {
                id: 'productWise',
                title: 'ProductWise R ',
                icon: <Circle size={12} />,
                navLink: '/reports/sale/productWise-report'
              },
              {
                id: 'nozzelWise',
                title: 'NozzelWise R',
                icon: <Circle size={12} />,
                navLink: '/reports/sale/nozzelWise-report'
              },
              {
                id: 'saleOpenClose',
                title: 'Sale Open Close ',
                icon: <Circle size={12} />,
                navLink: '/reports/sale/saleOpenClose'
              },
              {
                id: 'oil',
                title: 'Oil Report',
                icon: <Circle size={12} />,
                navLink: '/reports/sale/oil-report'
              },
              {
                id: 'productWise-details',
                title: 'ProductWise D  ',
                icon: <Circle size={12} />,
                navLink: '/reports/sale/productWise-details-report'
              },
              {
                id: 'tankWise-details',
                title: 'TankWise Det  ',
                icon: <Circle size={12} />,
                navLink: '/reports/sale/tankWise-details-report'
              },
              {
                id: 'nozzelWise-details',
                title: 'NozzelWise Det  ',
                icon: <Circle size={12} />,
                navLink: '/reports/sale/nozzelWise-details-report'
              }
        ]
      },
      {
        id: 'stock',
        title: 'Stock',
        icon: <Circle size={12} />,
        children: [
            {
              id: 'stockReport',
              title: 'Stock Report ',
              icon: <Circle size={12} />,
              navLink: '/reports/purchase/stock-report'
            },
            {
                id: 'variationReport',
                title: 'Variation Report ',
                icon: <Circle size={12} />,
                navLink: '/reports/purchase/variation-report'
              },
              {
                id: 'oilStockReport',
                title: 'Oil Stock Report ',
                icon: <Circle size={12} />,
                navLink: '/reports/purchase/oilStock-report'
              }
        ]
      },
      {
        id: 'creditClients',
        title: 'Credit Clients',
        icon: <Circle size={12} />,
        children: [
          // {
          //   id: "creditLedgerReportMoreshsir",
          //   title: " Ledger Testing ",
          //   icon: <Circle size={12} />,
          //   navLink: "/reports/creditClients/creditLedgerReportMoreshsir"
          // },
          {
            id: "creditLedgerReport",
            title: "Credit Ledger ",
            icon: <Circle size={12} />,
            navLink: "/reports/creditClients/creditLedgerReport"
          },
          {
            id: "billGeneration",
            title: "Bill Generation ",
            icon: <Circle size={12} />,
            navLink: "/reports/creditClients/billGeneration"
          },
          {
            id: "daywiseBillingReport",
            title: "Daywise Billing  ",
            icon: <Circle size={12} />,
            navLink: "/reports/creditClients/daywiseBillingReport"
          },
          {
            id: "creditRecieptReport",
            title: "Credit Reciept  ",
            icon: <Circle size={12} />,
            navLink: "/reports/creditClients/creditRecieptReport"
          },
          {
            id: "billwiseReport",
            title: "Billwise Report ",
            icon: <Circle size={12} />,
            navLink: "/reports/creditClients/billwiseReport"
          },
          {
            id: "outstandingReport",
            title: "Outstanding R",
            icon: <Circle size={12} />,
            navLink: "/reports/creditClients/outstandingReport"
          },
          {
            id: "productCreditSaleReport",
            title: "Product Credit S  ",
            icon: <Circle size={12} />,
            navLink: "/reports/creditClients/productCreditSaleReport"
          }
        ]
      },
      // {
      //   id: 'staff',
      //   title: 'Staff',
      //   icon: <Circle size={12} />,
      //   children: [
      //     {
      //       id: "overallStaffReport",
      //       title: "Overall Staff Report ",
      //       icon: <Circle size={12} />,
      //       navLink: "/reports/staff/overallStaffReport"
      //     },
      //     {
      //       id: "staffwiseSaleReport",
      //       title: "Staffwise Sale Report",
      //       icon: <Circle size={12} />,
      //       navLink: "/reports/staff/staffwiseSaleReport"
      //     },
      //     {
      //       id: "paymentReport",
      //       title: "Payment Report ",
      //       icon: <Circle size={12} />,
      //       navLink: "/reports/staff/paymentReport"
      //     },
      //     {
      //       id: "meterwiseSaleReport",
      //       title: "Meterwise Sale Report ",
      //       icon: <Circle size={12} />,
      //       navLink: "/reports/staff/meterwiseSaleReport"
      //     },
      //     {
      //       id: "meterReportDatewise",
      //       title: "Meter Report Datewise ",
      //       icon: <Circle size={12} />,
      //       navLink: "/reports/staff/meterReportDatewise"
      //     },
      //     {
      //       id: 'staffSallary',
      //       title: 'Staff Sallary',
      //       icon: <Circle size={12} />,
      //       navLink: '/report/staff/staffSallary'
      //     }
      //   ]
      // },
      {
        id: 'profit',
        title: 'Profit',
        icon: <Circle size={12} />,
        children: [
          // {
          //   id: "purchasewiseProfiteReport",
          //   title: "Purchasewise Profit Report ",
          //   icon: <Circle size={12} />,
          //   navLink: "/reports/profit/purchasewiseProfitReport"
          // },
          {
            id: "profitPerLiterReport",
            title: "Profit Per Liter ",
            icon: <Circle size={12} />,
            navLink: "/reports/profit/profitPerLiterReport"
          },
          {
            id: "rateDiffStockProfitReport",
            title: "Rate Diff Stock ",
            icon: <Circle size={12} />,
            navLink: "/reports/profit/rateDiffStockProfitReport"
          }
        ]
      },
      {
        id: 'handLoans',
        title: 'Hand Loans',
        icon: <Circle size={12} />,
        children: [
          {
            id: "paymentReport",
            title: "Payment Report ",
            icon: <Circle size={12} />,
            navLink: "/reports/handLoans/paymentReport"
          },
          {
            id: "recieptReport",
            title: "Reciept Report",
            icon: <Circle size={12} />,
            navLink: "/reports/handLoans/recieptReport"
          },
          {
            id: "paymentRecieptReport",
            title: "PaymentReciept  ",
            icon: <Circle size={12} />,
            navLink: "/reports/handLoans/paymentRecieptReport"
          },
          {
            id: "outstandingReport",
            title: "Outstanding R ",
            icon: <Circle size={12} />,
            navLink: "/reports/handloan/outstandingReport"
          }
        ]
      },
      {
        id: 'other',
        title: 'Other',
        icon: <Circle size={12} />,
        children: [
          {
            id: "chequeReport",
            title: "Cheque Report ",
            icon: <Circle size={12} />,
            navLink: "/reports/other/chequeReport"
          },
          {
            id: "expenseReport",
            title: "Expense Report",
            icon: <Circle size={12} />,
            navLink: "/reports/other/expenseReport"
          },
          {
            id: "cardReport",
            title: "Card Report ",
            icon: <Circle size={12} />,
            navLink: "/reports/other/cardReport"
          },
          {
            id: "productDensityReport",
            title: "Product Density  ",
            icon: <Circle size={12} />,
            navLink: "/reports/other/productDensityReport"
          },
          {
            id: "ledgerOutstandingReport",
            title: "Ledger Outstan",
            icon: <Circle size={12} />,
            navLink: "/reports/other/ledgerOutstandingReport"
          },
          
            {
              id: "rateReport",
              title: "Rate Report ",
              icon: <Circle size={12} />,
              navLink: "/reports/other/rateReport"
            }
        ]
      }
    ]
  },
  {
    id: 'account',
    title: 'Account',    
    icon: <User size={20} />,
    children: [
      {
        id: 'ledger',
        title: 'Ledger',
        icon: <Circle size={12} />,
        navLink: '/account/ledger'
      }
      // {
      //   id: 'voucher',
      //   title: 'Voucher',
      //   icon: <Circle size={12} />,
      //   navLink: '/account/voucher'
      // }
    ]
  },
  {
    header: 'DISPLAY'
  },
  {
    id: 'display',
    title: 'Display',    
    icon: <Clipboard size={20} />,
    children: [
      // {
      //   id: 'balanceSheet',
      //   title: 'Balance Sheet',
      //   icon: <Circle size={12} />,
      //   navLink: '/display/balanceSheet'
      // },
      // {
      //   id: 'profitAndLossSheet',
      //   title: 'Profit And Loss Sheet',
      //   icon: <Circle size={12} />,
      //   navLink: '/display/profitAndLossSheet'
      // },
      {
        id: 'oilGstReport',
        title: 'Oil GST Report',
        icon: <Circle size={12} />,
        navLink: '/display/oilGstReport'
      }
    ]
  },
  {
    header: "STAMPING"
  },
  {
    id: "stamping",
    title: "Stamping",
    icon: <Trello  size={12} />,
    navLink: "/stamping"
  }
]
